import React, { useCallback } from 'react';
import classNames from 'classnames/bind';
import Card from 'components/App/Card';
import ImagePreview from 'components/App/ImagePreview';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import { ReactComponent as EyeIcon } from 'assets/images/eye-icon.svg';
import DiscoverPlaces from '../DiscoverPlaces';
import styles from './styles.modules.scss';

const cx = classNames.bind(styles);

function ProvinceDetails({ provinceDetails, onEdit, onDelete }) {
  const handleViewOnBookese = useCallback(() => {
    const slug = provinceDetails?.slug || provinceDetails?._id || provinceDetails?.id;
    if (slug) {
      const baseUrl = process.env.REACT_APP_BOOKESE_URL || 'https://bookese.com';
      window.open(`${baseUrl}/explore/search/${slug}`, '_blank', 'noopener,noreferrer');
    }
  }, [provinceDetails]);

  return (
    <div className={cx('Container')}>
      <div className={cx('CardList')}>
        {/* ProvinceDetails */}
        <Card className={cx('Card')}>
          <div className={cx('Header')}>
            <div className={cx('HeaderContent')}>
              <div className={cx('ImageContainer')}>
                <img
                  src={provinceDetails.previewImage}
                  width={131}
                  height={74}
                  alt="province-avatar"
                  className={cx('Image')}
                />
              </div>

              <div className={cx('TitleContainer')}>
                <h2 className={cx('Title')}>{provinceDetails.name}</h2>
                <span className={cx('StatusBadge', {
                  'is-published': provinceDetails.isPublished,
                  'is-not-published': !provinceDetails.isPublished,
                })}
                >
                  {provinceDetails.isPublished ? 'Đã xuất bản' : 'Chưa xuất bản'}
                </span>
              </div>
            </div>

            <div className={cx('HeaderActions')}>
              <button
                type="button"
                className="button-action button-eye"
                onClick={handleViewOnBookese}
                title="Xem trên Bookese.com"
              >
                <EyeIcon />
              </button>
              <button
                type="button"
                className="button-action button-destructive"
                onClick={onDelete}
              >
                Xoá
              </button>
              <button
                type="button"
                className="button-action button-link"
                onClick={onEdit}
              >
                Chỉnh sửa
              </button>
            </div>
          </div>

          <div className={cx('Divider')} />

          <div className={cx('DescriptionSection')}>
            <h3 className={cx('SectionTitle', 'mb-2')}>
              Mô tả
            </h3>
            <p className={cx('DescriptionText', 'mb-0')}>
              {provinceDetails.description}
            </p>
          </div>

          <div className={cx('StatsSection')}>
            <Row>
              <Col md="4" className="mb-24">
                <div>
                  <h3 className={cx('SectionTitle', 'mb-2')}>
                    Hạng mục
                  </h3>

                  <div className={cx('CategoryList')}>
                    {provinceDetails.discoverCategories?.map((item) => (
                      <p key={item._id} className={cx('CategoryItem', 'mb-0')}>
                        {item.name}
                      </p>
                    ))}
                  </div>
                </div>
              </Col>

              <Col md="4" className="mb-24">
                <h3 className={cx('SectionTitle', 'mb-2')}>
                  Tổng điểm khám phá
                </h3>

                <p className={cx('CategoryItem', 'mb-0')}>
                  {provinceDetails.placeCount}
                </p>
              </Col>

              <Col md="4" className="mb-24">
                <h3 className={cx('SectionTitle', 'mb-2')}>
                  Tổng lượt đánh giá
                </h3>

                <p className={cx('CategoryItem', 'mb-0')}>
                  {provinceDetails.reviewCount}
                </p>
              </Col>
            </Row>
          </div>

          <div className={cx('ImageSection')}>
            <h3 className={cx('SectionTitle', 'mb-2')}>
              Hình ảnh
            </h3>

            {provinceDetails.images.length > 0 && (
              <ImagePreview
                images={provinceDetails.images}
                size={100}
              />
            )}
          </div>
        </Card>

        {/* DiscoverPlaces */}
        <DiscoverPlaces provinceDetails={provinceDetails} />
      </div>
    </div>
  );
}

export default ProvinceDetails;

ProvinceDetails.propTypes = {
  provinceDetails: PropTypes.instanceOf(Object).isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

ProvinceDetails.defaultProps = {
  onEdit: () => {},
  onDelete: () => {},
};
